import React from 'react';
import PropTypes from 'prop-types';
import { useRequestData } from 'wsm-common-data';
import { ButtonList } from 'wsm-vehicle-cta-display';

const VehicleCTA = ({ vehicleCTAs, isVehicleGallery }) => {
	const { deviceType } = useRequestData();
	const isMobile = deviceType === 'MOBILE';
	const ctaLocation = isVehicleGallery ? 'gallery' : 'sticky';
	if (vehicleCTAs.length > 0) {
		return (
			<div style={{ '--cst-img-height': isMobile ? '32px' : '52px' }}>
				<ButtonList
					buttons={vehicleCTAs}
					dataLocation=""
					ctaLocation={ctaLocation}
				/>
			</div>
		);
	} else {
		return null;
	}
};

export default VehicleCTA;

VehicleCTA.propTypes = {
	vehicleCTAs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
	isVehicleGallery: PropTypes.bool.isRequired
};
